import { render, staticRenderFns } from "./VersionSettings.vue?vue&type=template&id=39459919&lang=pug&"
import script from "./VersionSettings.vue?vue&type=script&lang=js&"
export * from "./VersionSettings.vue?vue&type=script&lang=js&"
import style0 from "./VersionSettings.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports